import {
  ScheduleMember,
  DefaultCrewMember,
  DefaultEquipmentMember,
  ScheduleEquipment,
} from '@services/schedules/internal/types';
import { getFullName } from '@utils/textHelpers';
import { SchedulerSidebarEquipmentMember, SchedulerSidebarCrewMember } from './types';
import { Dropdown } from '@contexts/dropdowns/types';
import { UsersDropdown } from '@services/dropdowns/types';

export const getCrewMembersFromForeman = (
  foremanId: string,
  fieldUsers: Dropdown<UsersDropdown[]>,
) => {
  if (!foremanId || !fieldUsers.options.length) return [];

  return fieldUsers.options.find((el) => el.id === foremanId)?.crewMembers || [];
};

export const getEquipmentMembersFromForeman = (
  foremanId: string,
  fieldUsers: Dropdown<UsersDropdown[]>,
) => {
  if (!foremanId || !fieldUsers.options.length) return [];

  return fieldUsers.options.find((el) => el.id === foremanId)?.assetMembers || [];
};

export const mapCrewMembersToSchedulerSidebarCrewMembers = (
  crewMembers: DefaultCrewMember[],
): SchedulerSidebarCrewMember[] => {
  return crewMembers
    .map((el) => ({
      userId: el.id,
      name: getFullName(el.firstName, el.lastName),
      roles: el.roles || [],
      conflicts: el.conflicts || [],
      userDeactivated: !!el.discardedAt,
    }))
    .filter((el) => !el.userDeactivated);
};

export const mapResponseScheduleMembersToForm = (
  scheduleMembers: ScheduleMember[],
): SchedulerSidebarCrewMember[] => {
  return scheduleMembers
    .map((el) => ({
      id: el.id,
      userId: el.user.id,
      name: getFullName(el.user.firstName, el.user.lastName),
      roles: el.user.roles,
      conflicts: el.conflicts || [],
      discardedAt: el.discardedAt,
      userDeactivated: !!el.user.discardedAt,
    }))
    .filter((el) => !el.discardedAt);
};

export const mapEquipmentMembersToSchedulerSidebarCrewMembers = (
  equipmentMembers: DefaultEquipmentMember[],
): SchedulerSidebarEquipmentMember[] => {
  return equipmentMembers
    .map((el) => ({
      assetId: el.id,
      name: el.name,
      internalId: el.internalId,
      conflicts: el.conflicts || [],
      equipmentDeactivated: !!el.discardedAt,
    }))
    .filter((el) => !el.equipmentDeactivated);
};

export const mapResponseScheduleEquipmentToForm = (
  scheduleEquipment: ScheduleEquipment[],
): SchedulerSidebarEquipmentMember[] => {
  return scheduleEquipment
    .map((el) => ({
      id: el.id,
      assetId: el.asset.id,
      name: el.asset.name,
      internalId: el.asset.internalId,
      conflicts: el.conflicts || [],
      discardedAt: el.discardedAt,
      equipmentDeactivated: !!el.asset.discardedAt,
    }))
    .filter((el) => !el.discardedAt);
};

export const excludeFieldUserFromCrew = (
  crewMembers: SchedulerSidebarCrewMember[],
  fieldUserId: string,
) => {
  return crewMembers.filter((el) => el.userId !== fieldUserId);
};
